import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { LogOut, ArrowLeft } from "lucide-react";
import { api, formatErr } from "../lib/api";
import { Logo } from "../components/Logo";
import { AdminMessages } from "../components/admin/AdminMessages";
import { AdminClients } from "../components/admin/AdminClients";
import { AdminSubscribers } from "../components/admin/AdminSubscribers";

const Login = ({ onLogged }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mf-admin-token", data.token);
      onLogged(data);
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen grid place-items-center px-5 grid-lines bg-[var(--ink-2)] text-[rgba(246,241,232,0.9)]">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm bg-[var(--ink-2)] border border-[var(--line)] p-8 rounded-md">
        <Logo className="w-12 h-12" />
        <h1 className="display text-2xl mt-6">Area riservata</h1>
        <p className="text-sm text-[rgba(246,241,232,0.7)] mt-1">MF Logistics Consulting Group</p>
        <label className="block mt-8"><span className="mono text-[11px] uppercase text-[rgba(246,241,232,0.7)]">Email</span>
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" /></label>
        <label className="block mt-5"><span className="mono text-[11px] uppercase text-[rgba(246,241,232,0.7)]">Password</span>
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" /></label>
        {err && <p data-testid="admin-login-error" className="text-sm text-red-300 mt-4">{err}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-8 w-full rounded-full bg-[var(--amber)] text-[var(--ink)] py-3 font-semibold hover:bg-[var(--bone)] transition-colors disabled:opacity-60">
          {loading ? "Accesso…" : "Accedi"}
        </button>
        <Link to="/" data-testid="admin-back-home" className="mt-6 inline-flex items-center gap-2 text-sm text-[rgba(246,241,232,0.7)] hover:text-[var(--amber)]"><ArrowLeft className="w-4 h-4" />Torna al sito</Link>
      </form>
    </div>
  );
};

const Dashboard = ({ user, onLogout }) => {
  const [tab, setTab] = useState("messages");
  return (
    <div className="min-h-screen bg-[var(--ink-2)] text-[rgba(246,241,232,0.9)]">
      <header className="border-b border-[var(--line)] bg-[var(--ink-2)]">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3"><Logo className="w-8 h-8" /><span className="display text-sm hidden sm:inline">Admin</span></Link>
          <div className="flex items-center gap-4"><span className="text-sm text-[rgba(246,241,232,0.7)] hidden sm:inline">{user.email}</span>
            <button data-testid="admin-logout" onClick={onLogout} className="flex items-center gap-2 text-sm border border-[var(--line)] rounded-full px-4 py-2 hover:border-[var(--amber)]"><LogOut className="w-4 h-4" />Esci</button></div>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 py-10">
        <div className="flex gap-2 mb-8">
          {[["messages", "Messaggi"], ["clients", "Clienti"], ["subscribers", "Newsletter"]].map(([k, l]) => (
            <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)}
              className={`rounded-full px-5 py-2 text-sm transition-colors ${tab === k ? "bg-[var(--amber)] text-[var(--ink)] font-semibold" : "border border-[var(--line)] hover:border-[var(--amber)]"}`}>{l}</button>
          ))}
        </div>
        {tab === "messages" ? <AdminMessages /> : tab === "clients" ? <AdminClients /> : <AdminSubscribers />}
      </div>
    </div>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)).finally(() => setChecking(false));
  }, []);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("mf-admin-token");
    setUser(null);
    toast("Disconnesso");
  };
  if (checking) return <div className="min-h-screen grid place-items-center mono text-sm">…</div>;
  return user ? <Dashboard user={user} onLogout={logout} /> : <Login onLogged={setUser} />;
}
